import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { downloadOrderPdf } from '../../redux/actions/purchaseOrders';

const DownloadPdfModal = ({ payload, settings, purchaseOrder, download, downloadUrl, showDownloadPdfModal, setShowDownloadPdfModal }) => {
  const [submitted, setSubmitted] = useState(false);
  const [downloadOptions, setDownloadOptions] = useState({});

  useEffect(() => {
    if(downloadUrl && submitted) { 
      setSubmitted(false);
      let win = window.open(downloadUrl, '_blank');
      win.focus();

      // TODO: set "now download? click here" message instead of closing
      setShowDownloadPdfModal(false);
    }
  }, [downloadUrl]);

  useEffect(() => {
    let taxColumn = settings.settings['tax_column'];

    if((settings.settings['tax_column'] === undefined) || (settings.settings['tax_column'] === null)) {
      taxColumn = true;
    }

    setDownloadOptions({
      poNum: (purchaseOrder?.supplier_order_number.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$') === null),
      invoiceNum: (purchaseOrder?.invoice_number.match('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$') === null),
      deliveryDate: true,
      paymentExpectedDate: true,
      adjustedPrice: !!(purchaseOrder?.adjusted_price),
      estimatedShippingPrice: !!(parseFloat(purchaseOrder?.shipping_price)),
      taxColumn: taxColumn
    })
  }, [purchaseOrder]);

  const toggleOption = (option) => {
    let newOptions = { ...downloadOptions };
    newOptions[option] = !newOptions[option];

    setDownloadOptions(newOptions);
  }
  
  const downloadPdf = () => {
    setSubmitted(true);
    download(payload, purchaseOrder?.id, downloadOptions);
  }

  return(
    <div className="main-overlay">
      <div className="main-popup main-popup-top-only main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowDownloadPdfModal()}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            <h3 className="main-popup__title">
              <span className="gwt-InlineHTML">Download PO PDF</span>
            </h3>
            <div className="main-popup__text" aria-hidden="true" style={{display: 'none'}}></div>
            <div className="main-popup__content">


              <h4><strong>{`${settings.settings['invoice_number_override'] || 'Invoice Number'}`}</strong>: { purchaseOrder?.invoice_number }</h4>
              <h4><strong>{`${settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}`}</strong>: { purchaseOrder?.supplier_order_number }</h4>

              <hr/>

              <h3>PDF Options</h3>

              <div className="a-card a-card--info a-card--info-blue">
                <div className="padding-15">
                  <span>Toggle options to appear in the PDF. Disabled options can be enabled in later downloads.</span>
                </div>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.invoiceNum} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('invoiceNum')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">{settings.settings['invoice_number_override'] || 'Invoice Number'}</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.poNum} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('poNum')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">{settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.deliveryDate} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('deliveryDate')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">Delivery Date</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.paymentExpectedDate} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('paymentExpectedDate')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">Payment Expected Date</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.adjustedPrice} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('adjustedPrice')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">Adjusted Price</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.estimatedShippingPrice} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('estimatedShippingPrice')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">Est. Shipping</span>
                </label>
              </div>

              <div className="custom-checkbox">
                <label>
                  <input type="checkbox" checked={downloadOptions.taxColumn} tabindex="0" className="custom-checkbox__input" onChange={() => toggleOption('taxColumn')}/>
                  <span className="custom-checkbox__label"></span>
                  <span className="custom-checkbox__text">Tax Column</span>
                </label>
              </div>

              <hr/>

              <button 
                className={`btn btn-primary ${submitted ? 'btn-loading' : ''}`}
                onClick={() => downloadPdf()}
                disabled={submitted}
              >
                Download PO PDF
              </button>

            </div>
          </div>
        </div>
      </div>
      
    </div>
  )

}

const mapStateToProps = state => ({ 
  settings: state.settings,
  downloadUrl: state.purchaseOrders.downloadUrl,
});

const mapDispatchToProps = (dispatch) => ({
  download: (payload, purchaseOrderId, options) => dispatch(downloadOrderPdf(payload, 'outstanding', purchaseOrderId, options)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPdfModal);